import { ProfitBasedAnalysis as Component } from './component';
import Connector from './connector';
import { ConnectorProfitBasedAnalysisProps } from './ProfitBasedAnalysis.proptype';

export interface ProfitBasedAnalysisProps extends Omit<ConnectorProfitBasedAnalysisProps, 'component'> {}

export const ProfitBasedAnalysis = (props: ProfitBasedAnalysisProps) => <Connector {...props} component={Component} />;
